<script setup lang="ts">
import type { DataItem as DispatchDriverJobsCustomTableDataItem } from '@/components/customTables/DispatchDriverJobsCustomTable.vue';

import DispatchDriverJobsCustomTable from '@/components/customTables/DispatchDriverJobsCustomTable.vue';

interface Props {
  dispatchDriverJobsCustomTableData?: DispatchDriverJobsCustomTableDataItem[];
}
export type TableFoldProps = Props;
const props = withDefaults(defineProps<Props>(), {
  dispatchDriverJobsCustomTableData: () => [],
});
</script>

<template>
  <section
    data-testid="dispatchDriversTableFold"
    :class="$style.dispatchDriversTableFold"
  >
    <DispatchDriverJobsCustomTable
      :data="props.dispatchDriverJobsCustomTableData"
    />
  </section>
</template>

<!-- prettier-ignore -->
<style module lang="scss">
@use '@/styles/colors';
@use '@/styles/variables';

.dispatchDriversTableFold {
}
</style>
